var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var SuccessDialog = require('../common/ok-message-dialog-with-action');
var Radio = require('backbone.radio');

var notificationsChannel = Radio.channel('notifications');

var PasswordChangeForm = Marionette.View.extend({
    template: require('../../templates/persons/password-change-form.html'),

    ui: {
        oldPass: '#old-password',
        newPass: '#new-password',
        newPassConfirm: '#new-password-confirmed',
        passwordHidden: '#password-hidden',
        saveBtn: '#save',
        cancelBtn: '#cancel',
        oldPasswordDiv: '#old-password-div',

        generatePass: '#generate-pass'
    },

    events: {
        'click @ui.saveBtn': 'save',
        'keyup @ui.newPass': 'validateNewPassword',
        'change @ui.newPass': 'validateNewPassword',
        'keyup @ui.newPassConfirm': 'validateNewPassword',
        'change @ui.newPassConfirm': 'validateNewPassword',
        'click @ui.generatePass': 'generatePass'
    },

    regions: {
        dialog: '#message-dialog'
    },

    generatePassButtonText: 'Generate and copy to clipboard',
    newPassword: undefined,

    templateContext: function () {
        var that = this;
        return {
            id: that.id,
            generatePassButtonText: this.generatePassButtonText
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'validateNewPassword', 'save', 'successCallBack', 'performRelogin', 'generatePass', 'hideOldPassword');
        this.id = options.id;
        this.utils = new CommonUtils();
        this.byAdmin = options.byAdmin;
        this.isSelf = options.isSelf;
        this.defaultPassword = options.defaultPassword;
    },

    onRender: function () {
        this.showChildView('dialog', new SuccessDialog({
            title: '',
            message: 'Password was changed',
            action: this.successCallBack
        }));
        if (this.byAdmin && !this.isSelf) {
            this.ui.oldPass.parent().parent().hide();
        }
        this.newPassword = '';
        this.validateNewPassword();
        this.hideOldPassword();
    },

    validateNewPassword: function () {
        var newPass = this.ui.newPass.val();
        var newPassConf = this.ui.newPassConfirm.val();

        var newPassError = this.passwordCheck(newPass);

        if (newPassError != '') {
            this.addTooltip(this.ui.newPass, newPassError);
            this.addErrorClass(this.ui.newPass);
            this.checkSaveBtn(false);
        } else {
            this.removeTooltip(this.ui.newPass);
            this.removeErrorClass(this.ui.newPass);
        }

        if (newPass != newPassConf) {
            this.addTooltip(this.ui.newPassConfirm, "Passwords do not match");
            this.addErrorClass(this.ui.newPassConfirm);
            this.checkSaveBtn(false);
        } else {
            this.removeTooltip(this.ui.newPassConfirm);
            this.removeErrorClass(this.ui.newPassConfirm);
        }

        if (newPassError == '' && newPass == newPassConf) {
            this.checkSaveBtn(true);
        }
    },

    checkSaveBtn: function (result) {
        if (result)
            this.ui.saveBtn.removeAttr("disabled");
        else
            this.ui.saveBtn.attr("disabled", "true");
    },

    save: function () {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/person/change/password/' + that.id,
            data: {
                oldPassword: that.ui.oldPass.val(),
                newPassword: that.ui.newPass.val()
            },
            dataType: 'text',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    that.newPassword = that.ui.newPass.val();
                    that.getChildView('dialog').show();
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
            }
        });
    },

    addTooltip: function (jQelement, text) {
        jQelement.tooltip({title: text});
    },

    removeTooltip: function (jQelement) {
        jQelement.tooltip("destroy");
    },

    addErrorClass: function (jQelement) {
        jQelement.parent().parent().addClass('has-error has-feedback');
    },

    removeErrorClass: function (jQelement) {
        jQelement.parent().parent().removeClass('has-error has-feedback');
    },

    passwordCheck: function (value) {
        if (value.length < 8 || !(/[\d]/.test(value)) || !(/[a-z]/.test(value)) || !(/[A-Z]/.test(value))) {
            return "Password length should be at least 8 characters long and contains at least 1 letter, 1 digit and 1 capital letter.";
        } else {
            return "";
        }
    },

    successCallBack: function () {
        if (this.byAdmin && !this.isSelf/* || !this.defaultPassword*/) {
            Backbone.history.navigate('/person/' + this.id, {trigger: true});
        } else {
            this.performRelogin();
        }
    },

    performRelogin: function () {
        var that = this;
        $.ajax({
            type: "DELETE",
            url: '/api/login/session',
            statusCode: {
                200: function () {
                    Backbone.history.navigate('/login', {trigger: true});
                    /*$.ajax({
                        type: "POST",
                        url: '/api/login/auth?login=' + that.id + '&password=' + that.newPassword,
                        statusCode: {
                            200: function () {
                                Backbone.history.navigate('/documents?toReview=true&simpleMode=true', {trigger: true});
                            }
                        }
                    });*/
                }
            }
        });
    },

    generatePass: function () {
        var password = this.utils.generatePassword(8);
        this.ui.newPass.val(password);
        this.ui.newPassConfirm.val(password);
        this.ui.passwordHidden.val(password);
        this.ui.passwordHidden.show();
        this.ui.passwordHidden.select();
        document.execCommand('copy');
        this.ui.passwordHidden.hide();
        this.ui.passwordHidden.val('');

        this.ui.generatePass.toggleClass('btn-primary');
        this.ui.generatePass.toggleClass('btn-success');
        this.ui.generatePass.html('Copied');
        this.ui.generatePass.prop('disabled', function (i, v) {
            return !v;
        });

        var that = this;
        setTimeout(function () {
            that.ui.generatePass.toggleClass('btn-primary');
            that.ui.generatePass.toggleClass('btn-success');
            that.ui.generatePass.html(that.generatePassButtonText);
            that.ui.generatePass.prop('disabled', function (i, v) {
                return !v;
            });
        }, 1000);
        this.validateNewPassword();
    },

    hideOldPassword: function () {
        var that = this;
        Backbone.$.ajax({
            type: "GET",
            url: "/api/utility/instant/token/bysession",
            statusCode: {
                200: function (response) {
                    if (!_.isEmpty(response.id))
                        that.ui.oldPasswordDiv.hide();
                }
            }
        });
    }

});

module.exports = PasswordChangeForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/password-change-form.js
// module id = 451
// module chunks = 0